import { IdentificationBadge } from '@phosphor-icons/react';

export default IdentificationBadge;
